 <div class="flex items-center justify-between py-4">
    <h1 class="text-xl sm:text-xl font-semibold text-[#444A6D]">
      {{ 'SETUP.KIBOR.TITLE' | translate }}
    </h1>
   <div class="dv"></div>
  </div>
<!-- TABS (ADDED) -->
<app-tabs [tabs]="tabs"></app-tabs>
<router-outlet></router-outlet>